export default "__VITE_ASSET__BKJ809WL__"